import { Component, Inject, NgModule, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { HttpClient } from '@angular/common/http';
import { CommonService } from '../../service/common.service';
import { Lavorazione } from '../../models/lavorazione';
import { Statolavorazione } from '../../models/statolavorazione';
import { Commessa } from '../../models/commessa';
import { Tipolavorazione } from '../../models/tipolavorazione';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Lavorazionearticolo } from '../../models/lavorazionearticolo';
import { Articolo } from '../../models/articolo';

@Component({
  selector: 'app-add-lavorazione-dialog',
  templateUrl: './add-lavorazione-dialog.component.html',
  styleUrls: ['./add-lavorazione-dialog.component.css'],
 
})
export class AddLavorazioneDialogComponent implements OnInit {
  selectedValueStato: string;
  selectedValueTipolavorazione: string;
  lavorazione: Lavorazione;
  commessa: Commessa = new Commessa();
  codicecommessa: number;
  codicestatolavorazione: number;
  codicetipolavorazione: number;
  hide = true;
  stato: Statolavorazione;
  stati: Statolavorazione[];
  tipolavorazione: Tipolavorazione;
  tipilavorazione: Tipolavorazione[];

  rc: number;
  registerForm: FormGroup;
  submitted = false;

  ultimoimportoeditato:number;
  ultimaquantitaedidata:number;

  articolimodificati:Array<{Id: number, Modificato: string}>=[];
  lavorazionearticoli:Lavorazionearticolo[]=[];
  articoliselezionati: Articolo[]=[];
  isStatoDisabled: boolean = true;

  selectedArticolo: Articolo;
  dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
  filtroCodicearticolo:string;
  filtroDescrizione:string;
  articoli: Articolo[]=[];
  articoliincache: Articolo[]=[];
  dataSource = new MatTableDataSource<Articolo>(this.articoli);
  sortedDirection:Map<string, boolean>=new Map<string, boolean>();
  @ViewChild('paginator') paginator: MatPaginator;
  displayedColumns: string[] = [
  //  "sel",
  //  "Id",
    "Codicearticolo",
    "Descrizione",
  //  "Categoria",
    "Costo",
    "Iva",
    "Prezzo",
    "Giacenza",
    "Unitamisura",
    "add"];

  displayedColumns2: string[] = [
  //    "sel2",
    "Quantita",
    "Id",
    "Codicearticolo",
    "Descrizione",
    "Costo",
    "Iva",
    "Prezzo",
    "Unitamisura",
    "Prezzototale",
    "save",];

    private searchTimeoutCodice: any; 
    private searchTimeout: any; 
    private readonly DEBOUNCE_DELAY = 2000; // 1000 millisecondi

  constructor(
    private httpClient: HttpClient,
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddLavorazioneDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Se ci sono dati passati al dialog, inizializza la commessa
    if (data) {
      this.codicecommessa = data.codicecommessa;
      this.codicestatolavorazione = data.codicestatolavorazione;
      this.codicetipolavorazione = data.codicetipolavorazione;  
    }
  }

  ngOnInit(): void {
    if (this.registerForm === undefined) {
      this.registerForm = this.formBuilder.group({
        selectedValueStato: [''],
        selectedValueTipolavorazione: ['', Validators.required],
        Codice: [0],
        Nome: ['', Validators.required],
        Nomestato: [''],
        Codicecommessa: [0],
        Codicestatolavorazione: [0],
        Codicetipolavorazione: [0],
        Importo: [0],
        Quantita: [0],
        Sconto: [0],
        Subtotale: [0],
      });
    }

    this.lavorazionearticoli=[];

     

    this.commonService.getAllStatilavorazioni().subscribe((res) => {
      this.stati = res;
      this.stato = this.stati[this.codicestatolavorazione];
      this.commonService.getAllTipilavorazione().subscribe((res1) => {
        this.tipilavorazione = res1;
       

        if (this.data) {

         this.tipilavorazione.forEach(tipolavorazione => {
          if (tipolavorazione.Codice === this.data.codicetipolavorazione) {
            this.tipolavorazione = tipolavorazione;
          }
         });

         this.stati.forEach(stato => {
          if (stato.Codice === this.data.codicestatolavorazione) {
            this.stato = stato;
          }
         });
  
          if (this.data.codicelavorazione===0) {
            this.lavorazione = new Lavorazione();
          }

        

          this.registerForm.setValue({
            selectedValueStato: this.stato.Nome,
            selectedValueTipolavorazione: this.tipolavorazione.Nome,
            Codice: this.lavorazione.Codice,
            Nome: this.lavorazione.Nome,
            Nomestato: this.lavorazione.Statolavorazione.Nome,
            Codicecommessa: this.data.codicecommessa,
            Codicestatolavorazione: this.data.codicestatolavorazione,
            Codicetipolavorazione: this.data.codicetipolavorazione,
            Importo: 0,
            Quantita: 0,
            Sconto: 0,
            Subtotale: 0
          });
        } 
        this.lavorazione.Commessa = this.commessa;
        this.lavorazione.Codicecommessa = this.commessa.Codice;
      });
    });
  }

  refreshLista(listaarticoli:Articolo[]){
    this.articoli=listaarticoli;
    this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
    this.dataSource.paginator = this.paginator;
  }

  aggiornaForm() {
    this.registerForm.setValue({
      selectedValueStato: this.stato.Nome,
      selectedValueTipolavorazione: this.lavorazione.Tipolavorazione.Nome,
      Codice: this.lavorazione.Codice,
      Nome: this.lavorazione.Nome,
      Nomestato: this.lavorazione.Statolavorazione.Nome,
      Codicecommessa: this.lavorazione.Commessa.Codice,
      Codicestatolavorazione: this.lavorazione.Statolavorazione.Codice,
      Codicetipolavorazione: this.lavorazione.Tipolavorazione.Codice
    });
  }

  manageChangeStato() {
    if (this.registerForm.value.selectedValueStato === undefined) {
      return;
    }
    this.stati.forEach(element => {
      if (this.registerForm.value.selectedValueStato === element.Nome) {
        this.stato = element;
        this.lavorazione.Statolavorazione = this.stato;
      }
    });
    this.aggiornaForm();
  }

  manageChangeTipolavorazione() {
    let nometipolavorazione = this.registerForm.controls['selectedValueTipolavorazione'].value;
    this.tipilavorazione.forEach(element => {
      if (nometipolavorazione === element.Nome) {
        this.tipolavorazione = element;
        this.lavorazione.Tipolavorazione = this.tipolavorazione;
      }
    });
    this.registerForm.controls['Nome'].setValue(this.tipolavorazione.Nome);
    this.registerForm.controls['Codicetipolavorazione'].setValue(this.tipolavorazione.Codice);
    this.registerForm.controls['Quantita'].setValue(0);
    this.registerForm.controls['Importo'].setValue(0);

    if (this.tipolavorazione.Codice === 1) {
       this.commonService.getAllArticoliflat().subscribe((res) => {
          this.articoli=res;
          this.articoliincache=res;
          this.refreshLista(this.articoli);      
      });
    }
  }
  
  isStatolavorazionedisabled():boolean {
    return this.registerForm.controls['selectedValueStato'].value != '';
  }
  isTipolavorazionemanuale():boolean {
    return this.registerForm.controls['selectedValueTipolavorazione'].value === 'Manuale';
  }

  isTipolavorazioneMateriali():boolean {
    if (this.lavorazione.Tipolavorazione === undefined) {
      return false;
    }
    return this.lavorazione.Tipolavorazione.Codice === 1;
  }
  

  get f() { return this.registerForm.controls; }

  onAnnulla(): void {
    this.dialogRef.close();
  }

  onSalva(): void {
    
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      alert("Errore: verifica i campi indicati con *");
      return;
    }
    let la:Lavorazionearticolo=new Lavorazionearticolo();
    this.registerForm.controls['Sconto'].setValue(0);
    this.registerForm.controls['Subtotale'].setValue(la.Prezzo);
    if (this.tipolavorazione.Codice === 1) {
                la.Articolo=this.selectedArticolo;
                la.Costo=this.selectedArticolo.Costo;
                la.Unitamisura=this.selectedArticolo.Unitamisura;
                let iva=this.selectedArticolo.Costo*this.selectedArticolo.Iva/100;
                la.Iva=Number(iva.toFixed(2));
                let prezzo=la.Costo+la.Iva;
                la.Prezzo=Number(prezzo.toFixed(2));
                

                this.registerForm.controls['Nome'].setValue(this.selectedArticolo.Codicearticolo+" - "+this.selectedArticolo.Descrizione);
                this.registerForm.controls['Importo'].setValue(la.Prezzo);
 
                     
        }

    this.commonService.saveLavorazione(this.registerForm.value).subscribe(data => {
      this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
              //console.log("--->SaveUser"+this.rc.toString());
      if (this.rc===0){
        alert("Lavorazione già esistente");
      }else if (this.rc===-1){
        alert("Errore creazione lavorazione");
      }else {
        //alert("Lavorazione salvata con successo");
        if (this.tipolavorazione.Codice === 1) {
                
                la.Lavorazioneid=this.rc;
                la.Articolo=this.selectedArticolo;
                la.Costo=this.selectedArticolo.Costo;
                la.Unitamisura=this.selectedArticolo.Unitamisura;
                let iva=this.selectedArticolo.Costo*this.selectedArticolo.Iva/100;
                la.Iva=Number(iva.toFixed(2));
                let prezzo=la.Costo+la.Iva;
                la.Prezzo=Number(prezzo.toFixed(2));
                this.commonService.saveLavorazionearticolo(la).subscribe((data) => {
                  let rc: number;
                  rc=Number(JSON.stringify(data));
                  if (rc>0){
                    alert("Articolo aggiunto correttamente");
                  // la.Id=rc;
                  // this.lavorazionearticoli.push(la);
                  // this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
                  }else{
                    alert("Errore nella aggiunta dell'elemento selezionato");
                  }
                });     
        }
     }
   });

    this.dialogRef.close(this.registerForm.value);
  }
  onQuantitaKeyup(e: any) {
    // Impedisce l'inserimento di caratteri non numerici
     if (isNaN(e.target.value)){
      this.registerForm.controls['Quantita'].setValue(this.ultimaquantitaedidata);
    }else{
      this.ultimaquantitaedidata=Number(this.registerForm.controls['Quantita'].value);  
    }
  }
   onImportoKeyup(e: any) {
    // Impedisce l'inserimento di caratteri non numerici
     if (isNaN(e.target.value)){
      this.registerForm.controls['Importo'].setValue(this.ultimoimportoeditato);
    }else{
      this.ultimoimportoeditato=Number(this.registerForm.controls['Importo'].value);  
    }
  }

 onQuantitaLaKeyup(la:Lavorazionearticolo, event:any){
    if (isNaN(event.target.value)){
      event.target.value=la.Quantita;
    }else{
      la.Quantita=Number(event.target.value);
    }
    la.Prezzototale=Number((la.Prezzo*la.Quantita).toFixed(2));
    let index=this.articolimodificati.findIndex(a => a.Id=la.Id);
    if (index>-1){
      this.articolimodificati[index].Modificato='SI';
    }
  }

  onPrezzoKeyup(la:Lavorazionearticolo, event:any){
    if (isNaN(event.target.value)){
      event.target.value=la.Prezzo;
    }else{
      la.Prezzo=Number(event.target.value);
    }
    la.Prezzototale=Number((la.Prezzo*la.Quantita).toFixed(2));
    let index=this.articolimodificati.findIndex(a => a.Id=la.Id);
    if (index>-1){
      this.articolimodificati[index].Modificato='SI';
    }
  }

    saveArticolo(lavorazionearticolo:Lavorazionearticolo){
    this.commonService.saveLavorazionearticolo(lavorazionearticolo).subscribe((data) => {
      console.log("Salva:"+lavorazionearticolo.Articolo.Id);
      let rc: number;
      rc=Number(JSON.stringify(data));
      if (rc===lavorazionearticolo.Id){
        alert("Articolo salvato con successo");
        this.articolimodificati.push({Id:lavorazionearticolo.Id, Modificato:'NO'});
     
      }else if (rc===-2){
        alert("Quantità richiesta non sufficiente");
      }else if (rc===-1){
        alert("Errore salvataggio articolo selezionato");
      }
    });
  }

    onFiltroCodicearticoloKeyup(event:any){
    this.articoli=this.articoliincache;

    let searchValue: string='';
    if (event.target.value!=undefined){
       searchValue = event.target.value.toLowerCase();
    } 
    if (this.searchTimeoutCodice) {
      clearTimeout(this.searchTimeoutCodice);
    }

    this.searchTimeoutCodice = setTimeout(() => {
      this.articoli = this.articoli.filter(a=> (a.Codicearticolo!=null) && (a.Codicearticolo.toLowerCase().indexOf(event.target.value.toLowerCase())>-1 && (this.filtroDescrizione==="" || this.filtroDescrizione===undefined || a.Descrizione.toLowerCase().indexOf(this.filtroDescrizione.toLowerCase())>-1)));
   
      this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
      this.dataSource.paginator = this.paginator;
 
      }, this.DEBOUNCE_DELAY);
/*
    if (event.target.value!=undefined){
      this.articoli = this.articoli.filter(a=> a.Codicearticolo.toLowerCase().indexOf(event.target.value.toLowerCase())>-1 && (this.filtroDescrizione==="" || this.filtroDescrizione===undefined || a.Descrizione.toLowerCase().indexOf(this.filtroDescrizione.toLowerCase())>-1));
      this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
    }
      */
  }

  onFiltroDescrizioneKeyup(event:any){
    this.articoli=this.articoliincache;
    let searchValue: string='';
    if (event.target.value!=undefined){
       searchValue = event.target.value.toLowerCase();
    } 
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
      // Questa logica viene eseguita solo dopo 500ms di pausa.
      this.articoli = this.articoli.filter(a=> (a.Descrizione!=null) && (a.Descrizione.toLowerCase().indexOf(searchValue)>-1 && (this.filtroCodicearticolo==="" || this.filtroCodicearticolo===undefined || a.Codicearticolo.toLowerCase().indexOf(this.filtroCodicearticolo.toLowerCase())>-1)));
      this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
      this.dataSource.paginator = this.paginator;
    }, this.DEBOUNCE_DELAY);

   // if (event.target.value!=undefined){
   //   this.articoli = this.articoli.filter(a=> a.Descrizione.toLowerCase().indexOf(searchValue)>-1 && (this.filtroCodicearticolo==="" || this.filtroCodicearticolo===undefined || a.Codicearticolo.toLowerCase().indexOf(this.filtroCodicearticolo.toLowerCase())>-1));
   //   this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
    //}
  }

    addArticolo(articolo:Articolo){
      const indexOfObject = this.lavorazionearticoli.findIndex((element) => {
        return element.Articolo.Codicearticolo === articolo.Codicearticolo;
      });
      if (indexOfObject !== -1) {
        return;
      }

      this.selectedArticolo=articolo;
      this.onSalva();
 
  }

  getConfigurazione() {
    return configurazione.addlavorazionedialog;
  }

  manageClick(attributo: string){
    let tempList:Articolo[];
    tempList=this.articoli;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
  }
}
